import { IconButton } from '@roc/ui';
import Edit from '@material-ui/icons/Edit';
import { observer } from 'mobx-react-lite';
import {
  DataGrid,
  GridColumnProps,
} from '@roc/ui';
import BorrowerEntityStore from '../../../stores/documentForms/borrowerEntity/borrowerEntityStore';
import { insertIf } from '@roc/feature-utils';

interface BorrowerEntityGridProps {
  store: BorrowerEntityStore;
}

const BorrowerEntityGrid = observer(({ store }: BorrowerEntityGridProps) => {
  const { globalStore } = store;
  const { isInternalPortal, isAttorneyPortal } = globalStore;

  const membersColumns: GridColumnProps[] = [
    {
      field: 'fullName',
      headerName: 'Full Name',
    },
    {
      field: 'pctOwnership',
      headerName: 'Ownership percentage',
      cellRenderer: 'percentageCellRenderer',
    },
    {
      field: 'roleInEntity',
      headerName: 'Title',
      cellRenderer: 'textCellRenderer',
    },
    {
      field: 'authSignatory',
      headerName: 'Authorized Signatory',
    },
    {
      field: 'personalGuarantor',
      headerName: 'Personal Guarantor',
    },
    {
      field: 'stateForSigning',
      headerName: 'Signing State',
    },
    {
      field: 'countyForSigning',
      headerName: 'Signing County',
    },
    ...insertIf(isInternalPortal || isAttorneyPortal, [
      {
        headerName: 'Action',
        maxWidth: 100,
        cellRenderer: 'actionCellRenderer',
        width: 80,
        pinned: 'right',
        lockPinned: true,
      },
    ]),
  ];

  const frameworkComponents = {
    percentageCellRenderer({ value }: { value: number }) {
      return value != null ? `${value}%` : '';
    },

    actionCellRenderer: (params: any) => {
      return (
        <IconButton
          aria-label="edit"
          testId={`edit-borrower-${params.node.data?.borrowerId}`}
          onClick={() => store.editBorrower(params.node.data)}
        >
          <Edit color="primary" />
        </IconButton>
      );
    },
  };

  return (
    <DataGrid
      columns={membersColumns}
      frameworkComponents={frameworkComponents}
      rows={store.entityBorrowersGridStore.gridData.data.rows}
      isLoading={store.entityBorrowersGridStore.isLoading}
      domLayout="autoHeight"
    />
  );
});

export default BorrowerEntityGrid;
